import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import { navigate } from "@reach/router";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Layout from "../components/layout";
import SEO from "../components/seo";
import {
  loginUserWithEmailAndPassword,
  loginWithGoogle
} from "../actions/auth";

function Login(props) {
  const { loginUserWithEmailAndPassword, loginWithGoogle } = props;
  const [userCredentials, setUserCredentials] = useState({
    email: "",
    password: ""
  });

  const onChange = e => {
    setUserCredentials({ ...userCredentials, [e.target.name]: e.target.value });
  };
  const onSubmit = e => {
    e.preventDefault();

    // This is a redux action
    loginUserWithEmailAndPassword(
      userCredentials.email,
      userCredentials.password
    );
  };
  const onSignInWithGoogle = e => {
    loginWithGoogle();
  };

  useEffect(() => {
    if (props.auth.isAuthenticated) {
      navigate("/stories");
    }
  });

  return (
    <Layout>
      <SEO title="Log In"></SEO>
      <div
        style={{ maxWidth: 500 }}
        className="w-3/4 sm:w-3/5 md:w-1/2 lg:w-1/2 mx-auto mt-24 flex flex-col"
      >
        <h1 className="text-center font-bold">Log In</h1>
        <div className="my-4 flex justify-between">
          <button
            onClick={() => onSignInWithGoogle()}
            className="hover-up-sm text-white w-full p-3 rounded-lg shadow-lg font-sans"
            style={{ backgroundColor: `#4285F4` }}
          >
            Sign in with Google
          </button>
        </div>
        <div className="mt-2 flex items-center w-full">
          <div className="flex-1 h-px border-t" />
          <span className="mx-2 font-bold text-inverse">OR</span>
          <div className="flex-1 h-px border-t" />
        </div>
        <form
          onSubmit={e => onSubmit(e)}
          className="mt-4 w-full flex flex-col font-sans"
        >
          <div className="mt-3 w-full relative rounded overflow-hidden bg-gray-200">
            <div className="absolute inset-y-0 pl-2 flex items-center fill-current text-gray-600 ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                className="fill-current text-gray-600 "
              >
                <path
                  fillRule="evenodd"
                  d="M21,7.38246601 L21,5 L3,5 L3,7.38199365 L12.0000224,11.8824548 L21,7.38246601 Z M21,9.61853399 L11.9999776,14.1185452 L3,9.61810635 L3,19 L21,19 L21,9.61853399 Z M3,3 L21,3 C22.1045695,3 23,3.8954305 23,5 L23,19 C23,20.1045695 22.1045695,21 21,21 L3,21 C1.8954305,21 1,20.1045695 1,19 L1,5 C1,3.8954305 1.8954305,3 3,3 Z"
                />
              </svg>
            </div>
            <input
              className="p-2 pl-10 h-full w-full bg-gray-200 placeholder-gray-600"
              placeholder="Email"
              type="email"
              name="email"
              value={userCredentials.email}
              onChange={e => onChange(e)}
            />
          </div>
          <div className="mt-2 w-full relative rounded overflow-hidden bg-gray-200">
            <div className="absolute inset-y-0 pl-2 flex items-center fill-current text-gray-600">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                className="fill-current "
              >
                <path
                  fillRule="evenodd"
                  d="M7 10V7a5 5 0 1110 0v3h1c1.068 0 2 .776 2 1.833v8.334C20 21.224 19.068 22 18 22H6c-1.068 0-2-.776-2-1.833v-8.334C4 10.776 4.932 10 6 10h1zm2 0h6V7a3 3 0 00-6 0v3zm-3 2v8h12v-8H6zm6 5a1 1 0 110-2 1 1 0 010 2z"
                />
              </svg>
            </div>
            <input
              className="p-2 pl-10 h-full w-full bg-gray-200 placeholder-gray-600 text-black"
              placeholder="Password"
              type="password"
              name="password"
              value={userCredentials.password}
              onChange={e => onChange(e)}
            />
          </div>
          <small className="mt-2 text-gray-600 underline">
            Forgot your password?
          </small>

          <button
            type="submit"
            className="mt-5 mx-auto w-full bg-indigo-700 text-white p-2 font-sans rounded-lg shadow-lg hover:bg-indigo-500"
          >
            Log In
          </button>
        </form>
        <div className="mt-6 w-full flex justify-center font-sans">
          <p>Don't have an account?</p>
          <Link className="ml-2 text-indigo-700 hover:underline" to="/register">
            <strong>Register</strong>
          </Link>
        </div>
      </div>
    </Layout>
  );
}

Login.propTypes = {
  auth: PropTypes.object.isRequired,
  loginUserWithEmailAndPassword: PropTypes.func.isRequired,
  loginWithGoogle: PropTypes.func.isRequired
};

const mapStateToProps = state => ({ auth: state.auth });

export default connect(
  mapStateToProps,
  { loginUserWithEmailAndPassword, loginWithGoogle }
)(Login);
